module.exports = __webpack_public_path__ + "img/games-6.96031e50.webp";